import { Box, Link, Typography, Button } from '@mui/material'
import React from 'react'

import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
// import DiscordIcon from '../../assets/myIcons';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const ContactInfo = ({sx}) => {
    
    const iconSize = '2rem'
    const footerIcons = [
        {name:'linked-in',path:'https://www.linkedin.com/company/pangu-design-build/' , icon:<LinkedInIcon sx={{ fontSize: `${iconSize}`}}/>},
        {name:'facebook', path:'https://www.facebook.com/PanguEnterprises' ,icon:<FacebookIcon sx={{ fontSize: `${iconSize}`}}/>},
        {name:'X',path:'' , icon:<XIcon sx={{ fontSize: `${iconSize}`}}/>},
        {name:'instagram',path:'https://www.instagram.com/panguventures/' , icon:<InstagramIcon sx={{ fontSize: `${iconSize}`}}/>},
        // {name:'Pinterest', icon:<PinterestIcon />},
    ]

    const contactInfo = [
        {name: 'Email:', text:'info@pangu.ventures', path:'/'},
        {name: 'Phone:', text:'+1 (778) 651 - 8765', path:'/'},
    ]

  return (
    <Box
        sx={{
            ...sx,
            display:'flex',
            justifyContent:'center',
            // background:'linear-gradient(to bottom left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))',
            paddingY:'3rem',
            color:'#000',
            '@media screen and (max-width: 762px)':{
                paddingY:'1rem'
            }
        }}
    >
        <Box
            sx={{
                width:'30%',
                display:'flex',
                flexDirection:'column',
                '@media screen and (max-width:762px)':{
                    width:'100%',
                    padding:'1rem'
                }
            }}
        >
            <Typography
                variant='h1'
                sx={{
                    fontFamily:'var(--title-font)',
                    fontSize:'2rem',
                    textAlign:'center',
                    fontWeight:'500',
                    cursor:'pointer',
                    transition: 'transform 0.5s ease-in-out', // transition smoothing
                    '&:hover':{
                        transform:'scale(1.2)',
                        color:'blue',
                    },
                }}
            >
                <Link
                    href='/contact'
                    sx={{
                        textDecoration:'none',
                        color:'inherit'
                    }}
                >Contact Us</Link>
                </Typography>

            <Typography
                sx={{
                    textAlign:'center',
                    fontFamily:'var(--text-font)'
                }}
            >Do you have any questions? Please do not hesitate to reach out directly. Our team will get back to you shortly.</Typography>

            <Box
                sx={{
                    display:'flex',
                    flexDirection:'column',
                    paddingY:'1rem',
                    justifyContent:'center'
                }}
            >
                {contactInfo.map((item, index) => (
                    <Box
                        sx={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent:'center'
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily:'var(--text-font)'
                            }}
                        >{item.name}</Typography>
                        <Link
                            href={item.path}
                            sx={{
                                paddingLeft:'1rem',
                                textDecoration:'none',
                                // color:'var(--color-primary)'
                                color:'#000'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily:'var(--text-font)'
                                }}
                            >{item.text}</Typography>
                        </Link>
                    </Box>
                ))}
            </Box>

            <Typography
                sx={{
                    textAlign:'center',
                    fontFamily:'var(--text-font)'
                }}
            >
                Follow us on our social media channels
            </Typography>

            <Box
                    sx={{
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'center',
                        alignContent:'center',
                        alignItems:'center'

                    }}
                >
                    {footerIcons.map((icon, index) => (
                        <Box
                            sx={{                                
                            }}
                        >
                            <Button
                                href={icon.path}
                                target='_blank'
                                sx={{
                                    color:'#000'
                                }}
                            >{icon.icon}</Button>
                        </Box>
                    ))}
                </Box>
        </Box>
    </Box>
  )
}

export default ContactInfo